<template>
<div class="suifang">
  <div style="display: flex;align-items: center; margin-bottom: 10px;">
    <el-button style="width: 8em;margin-right: 20px;"  size="small" type="primary" @click="addshow">添加回访</el-button>
    <div class="gkly">
      <p style="margin-right: 10px;">最新随访：</p>
      <p style="margin-right: 10px;" v-if="hfArr.CRTime">{{hfArr.ExpertName}}</p>
      <el-button v-if="hfArr.CRTime" size="small" @click="cksf">详情</el-button>
    </div>
  </div>
  <ul class="title-ul">
    <li>回访编号</li>
    <li>回访时间</li>
    <li>回访类型</li>
    <li>回访方式</li>
    <li>回访状态</li>
    <li></li>
  </ul>
  <div class="right-box">
    <ul class="content-ul" v-for="(item, idx) in hflist" :key="idx">
      <li>{{item.CRId.slice(0, 8).toUpperCase()}}</li>
      <li>{{item.CRTime}}</li>
      <li>{{item.CRType}}</li>
      <li>{{item.CRMethod}}</li>
      <li>{{item.CRState}}</li>
      <li @click="ckhf(idx)"><p>查看详情</p></li>
    </ul>
  </div>


  <div class="mg" v-if="showadd">
    <div class="mgbox">
      <i class="el-icon-close gbs" @click="showadd=false"></i>
      <div class="hfwt">
        <span>回访时间：</span>
        <el-date-picker
            v-model="adddata.CRTime"
            type="datetime"
            :editable="false"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期">
        </el-date-picker>

        <span style="padding-left: 30px;">回访类型：</span>
        <el-select v-model="adddata.CRType" placeholder="请选择">
          <el-option
              v-for="item in hflx"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>


      <div class="hfwt">
        <span>回访方式：</span>
        <el-select v-model="adddata.CRMethod" placeholder="请选择">
          <el-option
              v-for="item in hffs"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>

        <span style="padding-left: 30px;">回访状态：</span>
        <el-select v-model="adddata.CRState" placeholder="请选择">
          <el-option
              v-for="item in hfzt"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>


      <div class="hfwt">
        <span>回访内容：</span>
        <el-input
            style="width: 60vw"
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="adddata.CRContent">
        </el-input>
      </div>

      <div class="hfwt">
        <span>顾客问题：</span>
        <el-input
            style="width: 60vw"
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="adddata.CRProblem">
        </el-input>
      </div>

      <el-button v-if="tebidx==1" style="margin-top: 30px;" type="primary" @click="savecsfh">提交</el-button>
      <el-button v-if="tebidx==2" style="margin-top: 30px;" type="primary" @click="savecsfh">更新</el-button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "suifang",
  data() {
    return {
      hflist: [],
      showadd: false,
      adddata: {},
      tebidx: 1,
      hfzt: [
        {
          value: '完成',
          label: '完成'
        },
        {
          value: '未完成',
          label: '未完成'
        }
      ],
      hffs: [
        {
          value: '电话',
          label: '电话'
        },
        {
          value: '微信',
          label: '微信'
        },
        {
          value: '上门',
          label: '上门'
        },
        {
          value: '到店',
          label: '到店'
        },
        {
          value: '邮件',
          label: '邮件'
        }
      ],
      hflx: [
        {
          value: '普通',
          label: '普通'
        },
        {
          value: '诊前',
          label: '诊前'
        },
        {
          value: '诊后',
          label: '诊后'
        },
        {
          value: '诊后术前',
          label: '诊后术前'
        },
        {
          value: '术后',
          label: '术后'
        },
        {
          value: '产品售后',
          label: '产品售后'
        },
        {
          value: '视觉训练',
          label: '视觉训练'
        },
        {
          value: '角膜塑形镜',
          label: '角膜塑形镜'
        }
      ],
      itemData: {},
      hfArr: {
        ExpertName: '',
        CRTime: '',
        CRType: '',
        CRMethod: '',
        CRProblem: '',
        CRContent: ''
      },
    }
  },
  created() {
    if (this.$store.state.users.CsUser) {
      this._api.userCurdApi.getSF()
          .then(res => {
            // console.log(res)
            if (res.Result && res.Result.length) {
              this.hfArr = JSON.parse(JSON.stringify(res.Result[0]))
            }
          })
      this.init()
    }
  },
  methods: {
    init() {
      this.itemData = JSON.parse(JSON.stringify(this.$store.state.users.CsUser))
      this._api.userCurdApi.CustomerReview_GetList( this.itemData.CustomerId)
          .then(res => {
            if (res.Result && res.Result.length) {
              this.hflist = [...res.Result]
            }else {
              this.hflist = []
            }
          })
    },
    ckhf(idx) {
      this.adddata = this.hflist[idx]
      this.showadd = true
      this.tebidx = 2
    },
    cksf() {
      this.adddata = this.hfArr
      this.showadd = true
      this.tebidx = 2
    },
    savecsfh() {
      if (!this.adddata.CRContent || !this.adddata.CRTime || !this.adddata.CRMethod || !this.adddata.CRType || !this.adddata.CRState)
        return this.$alert('请填写必要信息！', '提示')
      let url = 'CustomerReview_Insert'
      if (this.adddata.CRId) {
        url = 'CustomerReview_Update'
      }

      this._api.userCurdApi.CustomerReview_Insert(this.adddata, url)
          .then(res => {

            if (res.RecordCount && this.tebidx == 1) {
              this.init()
            }
            this.$alert(res.displaymsg, '提示')
            .then(r => {
              this.showadd = false
            })
          })
    },
    addshow() {
      if (!this.$store.state.users.employees) {
        return this.$router.push({path: '/employeesLanding'})
      }
      // console.log(this.itemData)
      this.tebidx = 1
      this.adddata = {
        "CRCompanyId":this.$store.state.users.user.Company.CompanyId,//Insert时必填
        "CRExpertId": this.$store.state.users.employees.ExpertId,//Insert时必填
        "CRChooseId": '',//可空
        "CRCustomerId": this.itemData.CustomerId,//Insert时必填
        "CRProblem":"",//可空
        //CRAddTime: '',
        "CRContent":"",//Insert时必填
        "CRTime":"",//Insert时必填
        "CRMethod":"",//Insert时必填
        "CRType":"",//Insert时必填
        "CRState":""//Insert时必填
      }
      this.showadd = true
    },
  }
}
</script>

<style scoped lang="scss">
.suifang {
  width: 800px;
}
.title-ul {
  display: flex;
  background: #000000;
  color: #ffffff;
  padding: 10px 0;
  li{
    width: 130px;
  }
}
.right-box {
  height: 450px;
  overflow-y: auto;
  .content-ul {
    display: flex;
    border-bottom: 1px solid #000000;
    color: #0a0a0a;
    li {
      width: 130px;
      padding: 10px 0;
      p {
        border: 1px solid #7f7e7e;
        border-radius: 5px;
        padding: 5px;
        cursor: pointer;
      }
    }
  }
}
.hfwt {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}
.mg {
  position: fixed;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.8);
  z-index: 999999;
  top: 0;
  left: 0;
  .mgbox {
    background: #FFFFFF;
    border-radius: 10px;
    padding: 30px 20px;
    position: relative;
  }
  .gbs {
    font-size: 30px;
    position: absolute;
    right: 10px;
    top: 10px;
    color: #ff0000;
    cursor: pointer;
  }
}
.gkly {
  display: flex;
  align-items: center;
}
</style>
